import React from 'react'

import SignIn from './SignIn'
import Seat from './Seat'
import styles from '../pages.module.scss'

const Home = () => {
  return (
    <div className={styles.home}>
      <Seat />
      <SignIn />
    </div>
  )
}

export default Home
